import { render } from "./AnnotateModal.vue?vue&type=template&id=ef811dbc&scoped=true"
import script from "./AnnotateModal.vue?vue&type=script&lang=js"
export * from "./AnnotateModal.vue?vue&type=script&lang=js"

import "./AnnotateModal.vue?vue&type=style&index=0&id=ef811dbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef811dbc"]])

export default __exports__